(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8214],{

/***/ 54949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _modules_study_blog_blog_single__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13915);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _unisearch_theme_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81496);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72145);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var BlogSingle = function BlogSingle(_ref) {
  var _pageData$author, _pageData$profileImag, _data$posterImage2, _data$featureImage2;

  var pageData = _ref.pageData,
      blog_slug = _ref.blog_slug;

  var data = _objectSpread({}, pageData);

  data.author = {
    authorName: pageData === null || pageData === void 0 ? void 0 : (_pageData$author = pageData.author) === null || _pageData$author === void 0 ? void 0 : _pageData$author.name,
    profileImageSrc: pageData === null || pageData === void 0 ? void 0 : (_pageData$profileImag = pageData.profileImage) === null || _pageData$profileImag === void 0 ? void 0 : _pageData$profileImag.src
  };
  var desc = data && data !== null && data !== void 0 && data.metaDescription ? data === null || data === void 0 ? void 0 : data.metaDescription : data !== null && data !== void 0 && data.content ? (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_4__/* .excerptWithRemoveQuote */ .Ld)(data === null || data === void 0 ? void 0 : data.content, 150) : "";

  var JsonLd = function JsonLd() {
    {
      var _data$posterImage, _data$featureImage;

      return {
        __html: "\n        [\n          {\n            \"@context\": \"https://schema.org\",\n            \"@type\": \"Organization\",\n            \"name\": \"UniSearch\",\n            \"alternateName\": \"UniSearch\",\n            \"url\": \"https://myunisearch.com/\",\n            \"logo\": \"".concat("https://myunisearch.com", "/assets/logo_dark.png\",\n            \"sameAs\": [\n              \"https://www.facebook.com/UniSearchIndia\",\n              \"https://twitter.com/myunisearch\",\n              \"https://www.youtube.com/channel/UCCHQrxOr5olDBxypJUE7qZw\",\n              \"https://myunisearch.com/\"\n            ]\n          },\n          {\n          \"@context\": \"https://schema.org\",\n          \"@type\": \"BlogPosting\",\n          \"mainEntityOfPage\": {\n               \"@type\": \"WebPage\",\n               \"@id\": \"").concat("https://myunisearch.com", "/blog/").concat(blog_slug, "\"\n          },\n          \"headline\": \"").concat(data !== null && data !== void 0 && data.metaTitle ? data === null || data === void 0 ? void 0 : data.metaTitle : data === null || data === void 0 ? void 0 : data.title, "\",\n          \"description\":\"").concat(desc, " | UniSearch\",\n          \"image\": \"").concat((data === null || data === void 0 ? void 0 : (_data$posterImage = data.posterImage) === null || _data$posterImage === void 0 ? void 0 : _data$posterImage.src) || (data === null || data === void 0 ? void 0 : (_data$featureImage = data.featureImage) === null || _data$featureImage === void 0 ? void 0 : _data$featureImage.src), "\",\n          \"author\": {\n               \"@type\": \"Organization\",\n               \"name\": \"UniSearch\"\n          },\n          \"datePublished\": \"").concat(data === null || data === void 0 ? void 0 : data.publishDate, "\"\n     }]\n    ")
      };
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_unisearch_theme_layout__WEBPACK_IMPORTED_MODULE_3__/* .LayoutMain */ .Ku, {
      ogType: "article",
      isLeadPopup: true,
      isHeaderSticky: true,
      title: data === null || data === void 0 ? void 0 : data.title,
      metaTitle: (data === null || data === void 0 ? void 0 : data.metaTitle) || (data === null || data === void 0 ? void 0 : data.title),
      metaKeywords: (data === null || data === void 0 ? void 0 : data.metaKeyword) || "unisearch, blog",
      metaDescription: data === null || data === void 0 ? void 0 : data.metaDescription,
      metaImage: (data === null || data === void 0 ? void 0 : (_data$posterImage2 = data.posterImage) === null || _data$posterImage2 === void 0 ? void 0 : _data$posterImage2.src) || (data === null || data === void 0 ? void 0 : (_data$featureImage2 = data.featureImage) === null || _data$featureImage2 === void 0 ? void 0 : _data$featureImage2.src),
      metaUrl: "".concat("https://myunisearch.com", "/blog/").concat(blog_slug),
      JsonLd: JsonLd,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_modules_study_blog_blog_single__WEBPACK_IMPORTED_MODULE_1__/* .BlogSingleHero */ .RK, {
        pageData: data
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_modules_study_blog_blog_single__WEBPACK_IMPORTED_MODULE_1__/* .BlogSingleBanner */ .o3, {
        blog: pageData
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_modules_study_blog_blog_single__WEBPACK_IMPORTED_MODULE_1__/* .BlogSingleBody */ .kS, {
        pageData: pageData
      })]
    })
  });
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (BlogSingle);

/***/ }),

/***/ 40315:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[blog_slug]",
      function () {
        return __webpack_require__(54949);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,5445,5937,2013,4617,955,9866,3874,6556,7662,3609,2884,8719,8322,1818,1496,7354,9774,2888,179], function() { return __webpack_exec__(40315); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);